module.exports = __webpack_public_path__ + "static/media/multiple_choice.859bf81f.jpg";